class AlfredService {
  constructor (Vue) {
    console.log('AlfredService initialized')
    this._Vue = Vue
    this.state = Vue.observable({
      actions: []
    })
  }

  setActions (actions) {
    if (actions && typeof actions.then === 'function') {
      actions
        .then((resolvedActions) => {
          this._Vue.set(this.state, 'actions', Array.isArray(resolvedActions) ? resolvedActions : [])
        })
        .catch((error) => {
          this._Vue.set(this.state, 'actions', [])
          console.warn('Failed to resolve Alfred actions:', error)
        })
      return
    }

    this._Vue.set(this.state, 'actions', Array.isArray(actions) ? actions : [])
  }

  getActions () {
    return this.state.actions
  }

  resetActions () {
    this._Vue.set(this.state, 'actions', [])
    console.log('Alfred actions reset')
  }

  triggerAction (actionName, payload) {
    const action = this.state.actions.find(a => a.name === actionName)
    if (action) {
      action.handler(payload)
    } else {
      console.warn(`Alfred action not found: ${actionName}`)
    }
  }
}
export default function install (Vue) {
  const alfred = new AlfredService(Vue)
  Object.defineProperty(Vue, '$alfred', { value: alfred })
  Object.defineProperty(Vue.prototype, '$alfred', { value: alfred })
}
